/*eslint eqeqeq: "off"*/
import TrendsVPIndex from 'components/MainPage/dcs/centumvp/components/Trends/index';
import TuningIndex from 'components/MainPage/dcs/centumvp/components/Tuning/TuningIndex';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { rootStore } from 'store';
import Reports from '../MainControl/Reports/index';
import AlarmsIndex from '../modules/alarms/index';
import GroupTrendIndex from '../modules/trends/GroupTrend/index';
import TrendsIndex from '../modules/trends/index';
import * as hmiclientsdata from './hmiclientsdata';
import * as HmiData from './hmidata';
import { SourceChange } from './hmiglobal';
import { MnemoParams } from './hooks/CentumVPScript';

interface AlarmsInterface {
    Alarms: any[];
    Top: any[];
}
export function CloseAll() {
    for (let ind = MnemoList.length; ind--; ) {
        CloseMnemo(ind);
    }
}

function CloseMnemo(ind: any) {
    let items = Object.keys(MnemoList[ind].tags);
    HmiData.UnSubItems(items);

    for (let i = 0; i < MnemoList[ind].reactnodes.length; i++) {
        let node = MnemoList[ind].reactnodes[i];
        //let res = ReactDOM.unmountComponentAtNode(node);
        node.unmount();
    }

    MnemoList.splice(ind, 1);
}

window.onbeforeunload = function (e: any) {
    CloseAll();

    return null;
};

export let MnemoList: any = [];

let ScriptDef: string = '';
let StyleDef: string = '';

export function SetScriptDef(str: string) {
    ScriptDef = str;
}

export function SetStyleDef(str: string) {
    StyleDef = str;
}

var idintervalrese: any = null;

function ResetCheckOpen() {
    if (blockloadmnemo) {
        blockloadmnemo = false;
        loadstackmnemo = new Array();
    }
}

var DecodeHTML = function (html: any) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};

export async function OpenMnemo(name: string, gennum: any, binding: any, parentElem: any, callbackEnd: any) {
    if (name != '' && parentElem != null) {
        let event = new CustomEvent('OpenMnemoFile', { detail: { name: name } });
        document.dispatchEvent(event);

        let loadmnemoo: any = {};
        loadmnemoo.name = name;
        loadmnemoo.gennum = gennum;
        loadmnemoo.binding = binding;
        loadmnemoo.parentElem = parentElem;
        loadmnemoo.callbackEnd = callbackEnd;

        if (blockloadmnemo) {
            loadstackmnemo.push(loadmnemoo);
            return;
        }

        if (idintervalrese) {
            clearTimeout(idintervalrese);
            idintervalrese = null;
        }
        idintervalrese = setTimeout(ResetCheckOpen, 7000);

        blockloadmnemo = true;

        let func = function (response: any, loadmnemoo: any) {
            blockloadmnemo = false;
            if (response != null) {
                try {
                    let name = loadmnemoo.name;
                    let gennum = loadmnemoo.gennum;
                    let binding = loadmnemoo.binding;
                    let parentElem = loadmnemoo.parentElem;
                    let callbackEnd = loadmnemoo.callbackEnd;

                    if (!parentElem) {
                        console.log('Not obg load mnemo');
                        return;
                    }
                    if (parentElem.nodeName.toUpperCase() == 'IFRAME') {
                        UnSubItem(parentElem.contentDocument);
                    } else {
                        UnSubItem(document);
                    }

                    let elem = response;

                    let newcurobject = { obj: elem, tags: [], framewindow: window, reactnodes: [], state: 0 };
                    MnemoList.push(newcurobject);
                    if (elem) {
                        newcurobject.obj = elem;

                        let bindingobjmnemoinfo: any = {};
                        if (binding != null) {
                            let persplitbindingmnemoinfo = DecodeHTML(binding).split('&');

                            for (let i = 0; i < persplitbindingmnemoinfo.length; i++) {
                                let persplitrav = persplitbindingmnemoinfo[i].split('=');
                                bindingobjmnemoinfo[persplitrav[0].toUpperCase()] = persplitrav[1].toUpperCase();
                            }
                        }

                        let mnemoinfo = {
                            file: name,
                            bindings: binding
                        };

                        elem.setAttribute('data-mnemoinfo', JSON.stringify(mnemoinfo));

                        elem.id = `f${(+new Date()).toString()}`;

                        ReplaceConstants(elem);

                        Bindings(binding, elem);

                        SetBindings(gennum, elem);

                        SubItemsDoc(elem);

                        findElementsWithOpenFaceplate(elem, name);

                        let ondblclickElem = elem.querySelectorAll('svg [ondblclick]');
                        for (let elemdb of ondblclickElem) {
                            let dblclick_fn_txt = ' if(event.detail == 2) {' + elemdb.getAttribute('ondblclick') + '};';
                            let newonclick = elemdb.getAttribute('onclick') + dblclick_fn_txt;
                            elemdb.setAttribute('onclick', newonclick);
                            elemdb.removeAttribute('ondblclick');
                        }

                        let he = document.body.offsetHeight * 1.8;

                        if (elem.width) elem.width.baseVal.valueAsString = '100%';

                        let heightMnemSVG = he;

                        if (elem.height) {
                            if (elem.viewBox.baseVal) {
                                heightMnemSVG = elem.viewBox.baseVal.height;
                            } else {
                                heightMnemSVG = document.body.getClientRects()[0].height - 50;
                            }
                        }

                        if (he < heightMnemSVG) {
                            if (elem.height) elem.height.baseVal.valueAsString = heightMnemSVG;
                        } else {
                            if (elem.height) elem.height.baseVal.valueAsString = '100%';
                            if (elem.style) {
                                elem.style.width = '100%';
                                elem.style.height = '100%';
                            }
                        }

                        let preserveAspectRatio = elem.getAttribute('preserveAspectRatio');

                        ///отключить автомасштаб
                        if (parentElem.style && elem.viewBox) {
                            if (parentElem.style.overflow == 'auto' || preserveAspectRatio == 'slice') {
                                let widthSVG = elem.viewBox.baseVal.width;
                                let heightSVG = elem.viewBox.baseVal.height;

                                if (elem.width) elem.width.baseVal.valueAsString = widthSVG;
                                if (elem.height) elem.height.baseVal.valueAsString = heightSVG;

                                if (elem.style) {
                                    elem.style.width = widthSVG;
                                    elem.style.height = heightSVG;
                                }
                            }
                        }
                    }

                    if (parentElem.nodeName.toUpperCase() == 'IFRAME') {
                        let clone = parentElem.cloneNode(false);
                        clone.onload = null;
                        parentElem.replaceWith(clone);

                        parentElem = clone;

                        newcurobject.framewindow = parentElem.contentWindow;

                        let parentElemdoc = parentElem.contentDocument;

                        let htmlnew = document.createElement('html');
                        let scripttext = ScriptDef;

                        let styletext = StyleDef;

                        htmlnew.innerHTML =
                            "<head>  <base href='hmi' /> " +
                            styletext +
                            scripttext +
                            "</head><body style='overflow: auto; margin: 0'>" +
                            '</body>';

                        if (elem.nodeName.toLowerCase() != 'html') {
                            parentElemdoc.onload = null;
                            parentElemdoc.open();
                            parentElemdoc.write(htmlnew.outerHTML);
                            parentElemdoc.close();

                            if (parentElemdoc.body == null) {
                                parentElem.onload = function () {
                                    const config = { childList: true };

                                    let listenerload = (mutationsList: any, observer: any) => {
                                        //elem.removeEventListener("DOMContentLoaded", listenerload, false);
                                        observer.disconnect();
                                        goodload(parentElem, callbackEnd, elem, newcurobject.framewindow);
                                    };

                                    const observer = new MutationObserver(listenerload);

                                    //elem.addEventListener("DOMContentLoaded", listenerload, false);

                                    observer.observe(parentElemdoc.body, config);

                                    parentElemdoc.body.append(elem);
                                };
                            } else {
                                const config = { childList: true };

                                let listenerload = (mutationsList: any, observer: any) => {
                                    //elem.removeEventListener("DOMContentLoaded", listenerload, false);
                                    observer.disconnect();
                                    goodload(parentElem, callbackEnd, elem, newcurobject.framewindow);
                                };

                                const observer = new MutationObserver(listenerload);

                                //elem.addEventListener("DOMContentLoaded", listenerload, false);

                                observer.observe(parentElemdoc.body, config);

                                parentElemdoc.body.append(elem);
                            }
                        } else {
                            let headpage = elem.querySelector('head');
                            if (headpage) {
                                headpage.innerHTML = headpage.innerHTML + StyleDef + ScriptDef;
                            }
                            parentElemdoc.write(elem.outerHTML);
                            parentElemdoc.close();
                        }

                        OpenFrame(parentElem);
                    } else {
                        parentElem.innerHTML = '';
                        parentElem.appendChild(elem);
                        goodload(parentElem, callbackEnd, elem, newcurobject.framewindow);
                    }
                } catch (e: any) {
                    console.log('Ошибка при откр.: ' + e.name + ':' + e.message + '\n' + e.stack);
                }
            } else {
                console.log('Файл отсутствует: ' + name);
            }
        };

        await GetFile(name, func, loadmnemoo, true);
    } else {
        console.log('OpenMnemo error args');
    }
}

function findElementsWithOpenFaceplate(svgElement: SVGSVGElement, namemnemo: string) {
    if (!MnemoParams[namemnemo]) {
        MnemoParams[namemnemo] = {
            Alarms: [],
            Top: []
        };
        MnemoParams[namemnemo].Alarms = [];
        MnemoParams[namemnemo].Top = [];

        let onclickElem = svgElement.querySelectorAll('[onclick]');
        onclickElem.forEach((child) => {
            const element = child as HTMLElement;
            const onClickValue = element.getAttribute('onclick');

            if (onClickValue && onClickValue.includes('OpenFaceplate')) {
                const regex = /OpenFaceplate\(([^)]+)\)/;
                const match = onClickValue.match(regex);

                if (match) {
                    const contentInsideBrackets = match[1].replace(/^'|'$/g, '');

                    MnemoParams[namemnemo].Alarms.push(contentInsideBrackets);
                }
            }
        });
    }
}

function OpenFrame(iframe: any) {
    //mousemove
    ///Плохо работает echart

    iframe.contentWindow.addEventListener('mousemove', function (event: any) {
        bubbleIframeMouseMove(event, iframe);
    });

    iframe.contentWindow.addEventListener('wheel', function (event: any) {
        bubbleIframeMouseWheel(event, iframe);
    });
}

function ReloadMnemo() {
    let newopeno = loadstackmnemo.shift();

    if (newopeno) {
        OpenMnemo(newopeno.name, newopeno.gennum, newopeno.binding, newopeno.parentElem, newopeno.callbackEnd);
    }
}

let bubbleIframeMouseMove = function (event: any, iframe: any) {
    let boundingClientRect = iframe.getBoundingClientRect();

    let evt: any = new CustomEvent('mousemove');

    evt.clientX = event.clientX + boundingClientRect.left;
    evt.clientY = event.clientY + boundingClientRect.top;

    window.Mouse = evt;
};

let bubbleIframeMouseWheel = function (event: any, iframe: any) {
    window.InputElementValue.EventUpdateDataScrol(event);
};

export function UnSubItem(doc: any) {
    let svg = doc.getElementsByTagName('svg');
    if (svg.length != 0) {
        let indoc: any = -1;
        for (let ind = MnemoList.length; ind--; ) {
            if (MnemoList[ind].obj.id === svg[0].id) {
                indoc = ind;
                break;
            }
        }
        if (indoc !== -1) {
            CloseMnemo(indoc);
        }
    }
}

export async function SubItemsDoc(doc: any) {
    let indoc: any = -1;
    for (let numdoc = MnemoList.length; numdoc--; ) {
        if (MnemoList[numdoc].obj === doc) {
            indoc = numdoc;
            break;
        }
    }
    if (indoc === -1) {
        let newcurobject: any = { obj: doc, tags: [], state: 1 };
        indoc = MnemoList.push(newcurobject);
        indoc = indoc - 1;
    }

    let items = SearthItemsMnemo(doc, indoc);

    await HmiData.SubItems(items);
}

export async function SubItemsElem(elem: any, doc: any) {
    let indoc: any = -1;
    for (let numdoc = MnemoList.length; numdoc--; ) {
        if (MnemoList[numdoc].obj === doc) {
            indoc = numdoc;
            break;
        }
    }

    if (indoc === -1) {
        return;
    }

    let items = SearthItemsMnemo(elem, indoc);
    await HmiData.SubItems(items);
}

function SearthItemsMnemo(initdoc: any, indoc: any): string[] {
    let Items: any = [];
    if (initdoc != null) {
        let dataLinkList = initdoc.getElementsByTagName('datalink');

        dataLinkList.source = new SourceChange(dataLinkList.id);

        let dataLinkCount = dataLinkList.length;

        for (let i = 0; i < dataLinkCount; i++) {
            let dataLinkObjectID = dataLinkList[i].parentNode.id;
            let objectanim = initdoc.querySelector("[data-datalinklistid='" + dataLinkObjectID + "'");

            if (objectanim !== null) {
                let conditionslist = dataLinkList[i].querySelectorAll('condition');
                conditionslist.forEach(function (condition: any) {
                    if (condition != undefined) {
                        if (condition.hasAttribute('value')) {
                            let valueC = condition.getAttribute('value');
                            let newvaluecode = HmiData.ConverStrToCode(valueC);
                            condition.setAttribute('value', newvaluecode.value);

                            let taglistC = newvaluecode.items;
                            for (let iC = 0; iC < taglistC.length; iC++) {
                                if (Items.indexOf(taglistC[iC]) === -1) {
                                    Items.push(taglistC[iC]);
                                }

                                SetItemDatalink(taglistC[iC], dataLinkList[i], indoc);
                            }
                        }
                    }
                });

                let scaleslist = dataLinkList[i].querySelectorAll('scale');
                scaleslist.forEach(function (scale: any) {
                    if (scale !== null) {
                        let valueS = null;
                        let taglistS = null;
                        let iS = 0;

                        if (scale.hasAttribute('lowlimit')) {
                            valueS = scale.getAttribute('lowlimit');
                            let newvaluecode = HmiData.ConverStrToCode(valueS);
                            scale.setAttribute('lowlimit', newvaluecode.value);

                            taglistS = newvaluecode.items;
                            for (iS = 0; iS < taglistS.length; iS++) {
                                if (Items.indexOf(taglistS[iS]) === -1) Items.push(taglistS[iS]);
                                SetItemDatalink(taglistS[iS], dataLinkList[i], indoc);
                            }
                        }

                        if (scale.hasAttribute('highlimit')) {
                            valueS = scale.getAttribute('highlimit');
                            let newvaluecode = HmiData.ConverStrToCode(valueS);
                            scale.setAttribute('highlimit', newvaluecode.value);

                            taglistS = newvaluecode.items;
                            for (iS = 0; iS < taglistS.length; iS++) {
                                if (Items.indexOf(taglistS[iS]) === -1) Items.push(taglistS[iS]);

                                SetItemDatalink(taglistS[iS], dataLinkList[i], indoc);
                            }
                        }

                        if (scale.hasAttribute('movefrom')) {
                            valueS = scale.getAttribute('movefrom');
                            let newvaluecode = HmiData.ConverStrToCode(valueS);
                            scale.setAttribute('movefrom', newvaluecode.value);

                            taglistS = newvaluecode.items;
                            for (iS = 0; iS < taglistS.length; iS++) {
                                if (Items.indexOf(taglistS[iS]) === -1) Items.push(taglistS[iS]);

                                SetItemDatalink(taglistS[iS], dataLinkList[i], indoc);
                            }
                        }

                        if (scale.hasAttribute('moveto')) {
                            valueS = scale.getAttribute('moveto');
                            let newvaluecode = HmiData.ConverStrToCode(valueS);
                            scale.setAttribute('moveto', newvaluecode.value);

                            taglistS = newvaluecode.items;
                            for (iS = 0; iS < taglistS.length; iS++) {
                                if (Items.indexOf(taglistS[iS]) === -1) Items.push(taglistS[iS]);

                                SetItemDatalink(taglistS[iS], dataLinkList[i], indoc);
                            }
                        }
                    }
                });

                let rowslist = dataLinkList[i].querySelectorAll('row');
                rowslist.forEach(function (row: any) {
                    let attrR = row.attributes;
                    for (let attrRI = 0; attrRI < attrR.length; attrRI++) {
                        let valueR = attrR[attrRI].value;
                        let newvaluecode = HmiData.ConverStrToCode(valueR);
                        attrR[attrRI].value = newvaluecode.value;

                        let taglistR = newvaluecode.items;

                        for (let iR = 0; iR < taglistR.length; iR++) {
                            if (Items.indexOf(taglistR[iR]) === -1) Items.push(taglistR[iR]);
                            SetItemDatalink(taglistR[iR], dataLinkList[i], indoc);
                        }
                    }
                });
            }
        }
    }
    return Items;
}

function AddItemList(item: any, indoc: any): boolean {
    if (MnemoList[indoc] != null) {
        if (MnemoList[indoc].tags[item] == undefined) {
            MnemoList[indoc].tags[item] = [];
            return true;
        }
    }
    return false;
}

function SetItemDatalink(item: any, datalink: any, indoc: any) {
    if (item != null) {
        item = item.toUpperCase();

        if (MnemoList[indoc] != null) {
            let retadd = AddItemList(item, indoc);
            if (retadd) {
                let ind = item.indexOf('.');
                if (ind != -1) {
                    let itemalarm = item.substring(0, ind);
                    AddItemList(itemalarm + '.ALARMS.ACK', indoc);
                    AddItemList(itemalarm + '.ALARMS.FL', indoc);
                    AddItemList(itemalarm + '.ALARMS.CV', indoc);
                    AddItemList(itemalarm + '.ALARMS.PR', indoc);
                }
            }
            if (MnemoList[indoc].tags[item].indexOf(datalink) === -1) MnemoList[indoc].tags[item].push(datalink);
            let ind = item.indexOf('.');
            if (ind != -1) {
                let itemalarm = item.substring(0, ind);
                if (MnemoList[indoc].tags[itemalarm + '.ALARMS.ACK'].indexOf(datalink) === -1)
                    MnemoList[indoc].tags[itemalarm + '.ALARMS.ACK'].push(datalink);
                if (MnemoList[indoc].tags[itemalarm + '.ALARMS.FL'].indexOf(datalink) === -1)
                    MnemoList[indoc].tags[itemalarm + '.ALARMS.FL'].push(datalink);
                if (MnemoList[indoc].tags[itemalarm + '.ALARMS.CV'].indexOf(datalink) === -1)
                    MnemoList[indoc].tags[itemalarm + '.ALARMS.CV'].push(datalink);
                if (MnemoList[indoc].tags[itemalarm + '.ALARMS.PR'].indexOf(datalink) === -1)
                    MnemoList[indoc].tags[itemalarm + '.ALARMS.PR'].push(datalink);
            }
        }
    }
}

export function ReplaceConstants(mnemo: any): any {
    let constantas = mnemo.getElementsByTagName('constanta');
    for (let i = 0; i < constantas.length; i++) {
        let nameConst = constantas[i].getAttribute('name').toUpperCase();
        {
            if (typeof hmiclientsdata.ConstantsXML?.querySelector === 'function') {
                let consObj = hmiclientsdata.ConstantsXML.querySelector("[name='" + nameConst.split('.')[1] + "']");
                if (consObj) {
                    constantas[i].parentNode.appendChild(consObj.children[0].cloneNode(true));
                    constantas[i].parentNode.removeChild(constantas[i]);
                    i--;
                }
            } else {
                //mnemo.innerHTML = "";
                console.log('constanta file not load');
            }
        }
    }
}

export function Bindings(name: string, mnemo: any) {
    if (name !== null) {
        let bindingsetlist;
        if (!mnemo.hasAttribute('data-bindingsetlistid')) {
            let bindingsetlists = mnemo.querySelector('bindingsetlists');
            if (bindingsetlists === null) {
                bindingsetlists = document.createElement('bindingsetlists');

                let foreignObject = mnemo.querySelector('#animationselement');
                if (foreignObject === null) {
                    foreignObject = document.createElement('foreignObject');
                    foreignObject.setAttribute('id', 'animationselement');
                    mnemo.appendChild(foreignObject);
                }
                foreignObject.appendChild(bindingsetlists);
            }
            bindingsetlist = document.createElement('bindingsetlist');
            bindingsetlists.appendChild(bindingsetlist);
            mnemo.setAttribute('data-bindingsetlistid', 'bindingsetlistmnemo');
        } else {
            bindingsetlist = mnemo.querySelector('#' + mnemo.getAttribute('data-bindingsetlistid'));
        }

        if (bindingsetlist !== null) {
            let persplit = new Array();
            let persplitrav = new Array();

            persplit = name.split('&');
            for (let i = 0; i < persplit.length; i++) {
                persplitrav = persplit[i].split('=');
                persplitrav[0] = '$' + persplitrav[0].toUpperCase();

                let binding;
                let bindinglist = bindingsetlist.querySelector('bindinglist[genericname="' + persplitrav[0] + '"]');

                if (bindinglist === null) {
                    bindinglist = document.createElement('bindinglist');
                    bindinglist.setAttribute('genericname', persplitrav[0]);
                    bindingsetlist.appendChild(bindinglist);
                    binding = document.createElement('binding');
                    binding.setAttribute('setnumber', '1');
                    bindinglist.appendChild(binding);
                } else {
                    binding = bindinglist.children[0];
                }

                binding.setAttribute('value', persplitrav[1]);
            }
        }
    }
}

export function SetBindings(num: any, mnemo: any) {
    SetBindElement(num, mnemo, mnemo);
    let bindingsetlists = mnemo.querySelector('bindingsetlists');
    if (bindingsetlists !== null) {
        bindingsetlists.parentElement.removeChild(bindingsetlists);
    }
}

function compareValue(a: string, b: string): any {
    if (a.length > b.length) return -1;
    if (a.length < b.length) return 1;
}

function SetBindElement(num: any, mnemo: any, elem: any) {
    if (elem.id.toLowerCase() != 'animationselement') {
        if (elem.hasAttribute('data-bindingsetlistid')) {
            let bindingsetlist = mnemo.querySelector('#' + elem.getAttribute('data-bindingsetlistid'));
            let genericAndValue: any = {};
            if (bindingsetlist != null) {
                let bindinglist = bindingsetlist.querySelectorAll('bindinglist');
                for (let ib = 0; ib < bindinglist.length; ib++) {
                    let genericName = bindinglist[ib].getAttribute('genericname');
                    if (genericName.indexOf('$') !== -1) {
                        let value =
                            num == 0
                                ? bindinglist[ib].querySelector('[setnumber]').getAttribute('value')
                                : bindinglist[ib].querySelector('[setname = "' + num + '"]').getAttribute('value');
                        let newdiv = document.createElement('div');
                        newdiv.innerHTML = value;
                        genericAndValue[genericName] = newdiv.innerHTML;
                    }
                }

                let sortgeneric = Object.keys(genericAndValue);

                //sortgeneric = sortgeneric.sort(compareValue);

                ///Замена от верхнего к нижнему
                sortgeneric.forEach(function (item, index, array) {
                    sortgeneric.forEach(function (itemrep, indexrep, arrayrep) {
                        if (index < indexrep) {
                            genericAndValue[itemrep] = genericAndValue[itemrep].replace(
                                new RegExp(item.replace(/[^\w\s]/g, '\\$&'), 'gi'),
                                genericAndValue[item]
                            );
                        }
                    });

                    for (let iatr = 0; iatr < elem.attributes.length; iatr++) {
                        elem.attributes[iatr].value = elem.attributes[iatr].value.replace(
                            new RegExp(item.replace(/[^\w\s]/g, '\\$&'), 'gi'),
                            genericAndValue[item]
                        );
                    }
                    if (elem.hasAttribute('data-datalinklistid')) {
                        let datalinklist = mnemo.querySelector('#' + elem.getAttribute('data-datalinklistid'));
                        if (datalinklist !== null)
                            datalinklist.innerHTML = datalinklist.innerHTML.replace(
                                new RegExp(item.replace(/[^\w\s]/g, '\\$&'), 'gi'),
                                genericAndValue[item]
                            );
                    }
                    let childelembinding = elem.children;
                    for (let ich = 0; ich < childelembinding.length; ich++) {
                        if (childelembinding[ich].hasAttribute('data-bindingsetlistid')) {
                            let bindingsetlistchil = mnemo.querySelector(
                                '#' + childelembinding[ich].getAttribute('data-bindingsetlistid')
                            );
                            if (bindingsetlistchil !== null) {
                                let bindings = bindingsetlistchil.querySelectorAll("binding[value*='" + item + "']");
                                if (bindings.length !== 0) {
                                    for (let ibin = 0; ibin < bindings.length; ibin++) {
                                        bindings[ibin].setAttribute(
                                            'value',
                                            bindings[ibin]
                                                .getAttribute('value')
                                                .replace(
                                                    new RegExp(item.replace(/[^\w\s]/g, '\\$&'), 'gi'),
                                                    genericAndValue[item]
                                                )
                                        );
                                    }
                                }
                                if (
                                    childelembinding[ich].nodeName.toLowerCase() === 'g' ||
                                    childelembinding[ich].nodeName.toLowerCase() === 'foreignobject'
                                ) {
                                    let bindinglistchild = bindingsetlistchil.querySelector(
                                        "bindinglist[genericname='" + item + "']"
                                    );
                                    if (bindinglistchild === null) {
                                        let newbindinglist = document.createElement('bindinglist');
                                        newbindinglist.setAttribute('genericname', item);
                                        let newbinding = document.createElement('binding');
                                        newbinding.setAttribute('setnumber', '1');
                                        newbinding.setAttribute('setname', '');
                                        newbinding.setAttribute('value', genericAndValue[item]);
                                        newbindinglist.appendChild(newbinding);
                                        bindingsetlistchil.appendChild(newbindinglist);
                                    }
                                }
                            }
                        } else if (
                            (childelembinding[ich].nodeName.toLowerCase() === 'g' ||
                                childelembinding[ich].nodeName.toLowerCase() === 'foreignobject') &&
                            index + 1 === sortgeneric.length
                        ) {
                            childelembinding[ich].setAttribute(
                                'data-bindingsetlistid',
                                elem.getAttribute('data-bindingsetlistid')
                            );
                        }
                    }

                    if (
                        elem.nodeName.toLowerCase() !== 'g' &&
                        elem.nodeName.toLowerCase() !== 'foreignobject' &&
                        elem.nodeName.toLowerCase() !== 'svg'
                    )
                        elem.innerHTML = elem.innerHTML.replace(
                            new RegExp(item.replace(/[^\w\s]/g, '\\$&'), 'gi'),
                            genericAndValue[item]
                        );
                });
            }
        }

        for (let ich = 0; ich < elem.children.length; ich++) {
            SetBindElement(0, mnemo, elem.children[ich]);
        }
    }
}

export async function goodload(parentElem: any, callbackEnd: any, loadmnemo: any, win: any) {
    blockloadmnemo = false;

    if (callbackEnd != undefined) {
        callbackEnd();
    }

    let onloadelem = null;

    let MnemoListCur: any = null;

    for (let i = 0; i < MnemoList.length; i++) {
        if (MnemoList[i].framewindow == win) {
            MnemoListCur = MnemoList[i];
        }
    }

    let plugins = loadmnemo.querySelectorAll('[data-vision-plugin]');
    let mnemoInfo = loadmnemo.getAttribute('data-mnemoinfo');
    if (plugins) {
        for (let i = 0; i < plugins.length; i++) {
            let plugName = plugins[i].getAttribute('data-vision-plugin');
            let plugParamStr = plugins[i].getAttribute('data-vision-plugin-param');
            if (plugName && plugParamStr) {
                let plugParam = JSON.parse(plugParamStr);

                if (plugParam != null) {
                    if (plugName == 'trends') {
                        const root = createRoot(plugins[i]);

                        root.render(
                            React.createElement(TrendsIndex, { id: plugins[i].id, config: JSON.stringify(plugParam) })
                        );

                        ///ожидание Render React, можно оптимизировать загрузку страницы
                        await new Promise((resolve) => setTimeout(resolve, 100));

                        MnemoListCur.reactnodes.push(root);
                    } else if (plugName == 'reports') {
                        const root = createRoot(plugins[i]);
                        root.render(
                            React.createElement(Reports, {
                                startFilterName: plugParam.config.startFilterName,
                                startFilterVal: plugParam.config.startFilterVal,
                                filterListCol: plugParam.config.filterListCol,
                                fullColList: plugParam.config.fullColList
                            })
                        );

                        MnemoListCur.reactnodes.push(root);
                    } else if (plugName == 'alarms') {
                        const root = createRoot(plugins[i]);
                        root.render(React.createElement(AlarmsIndex, { config: JSON.stringify(plugParam) }));

                        MnemoListCur.reactnodes.push(root);
                    } else if (plugName == 'tuningVP') {
                        const root = createRoot(plugins[i]);

                        root.render(
                            React.createElement(TuningIndex, {
                                id: plugins[i].id,
                                config: JSON.stringify(plugParam),
                                parentID: parentElem.id
                            })
                        );
                        await new Promise((resolve) => setTimeout(resolve, 100));

                        MnemoListCur.reactnodes.push(root);
                    } else if (plugName == 'trendsVP') {
                        const root = createRoot(plugins[i]);

                        const PenName = plugParam.tagConfig[0].name;

                        if (typeof mnemoInfo === 'string') {
                            mnemoInfo = JSON.parse(mnemoInfo);
                        }

                        root.render(
                            React.createElement(TrendsVPIndex, {
                                bindings: mnemoInfo.bindings,
                                TrendName: `centumtrends`,
                                parentID: parentElem.id,
                                id: `CentumVPTrends ${PenName}`
                            })
                        );

                        const newWidth = parentElem.offsetWidth;
                        const newHeight = parentElem.offsetHeight;
                        const foreignObject = loadmnemo.getElementsByTagName('foreignObject')[1];

                        loadmnemo.setAttribute('viewBox', `0 0 ${newWidth} ${newHeight}`);
                        foreignObject.setAttribute('width', newWidth);
                        foreignObject.setAttribute('height', newHeight);

                        window.ReactRoot = root;

                        await new Promise((resolve) => setTimeout(resolve, 100));

                        MnemoListCur.reactnodes.push(root);
                    } else if (plugName == 'trends_group') {
                        const root = createRoot(plugins[i]);

                        if (typeof mnemoInfo === 'string') {
                            mnemoInfo = JSON.parse(mnemoInfo);
                        }

                        root.render(
                            React.createElement(GroupTrendIndex, {
                                id: plugins[i].id,
                                config: JSON.parse(JSON.stringify(plugParam))
                            })
                        );

                        window.ReactRoot = root;

                        await new Promise((resolve) => setTimeout(resolve, 100));

                        MnemoListCur.reactnodes.push(root);
                    }
                }
            }
        }
    }

    if (parentElem.contentDocument) {
        onloadelem = parentElem.contentDocument.querySelectorAll('[onload]');
    } else {
        onloadelem = parentElem.querySelectorAll('[onload]');
    }

    for (const element of onloadelem) {
        if (element.nodeName.toUpperCase() !== 'IFRAME') {
            try {
                for (let iatr = 0; iatr < element.attributes.length; iatr++) {
                    element.attributes[iatr].value = element.attributes[iatr].value;
                }

                if (element.nodeName.toUpperCase() !== 'SVG') element.onload();
            } catch (ex) {}
        }
    }

    if (MnemoListCur != null) MnemoListCur.state = 1;

    let objload = document.getElementById('loadpage');
    if (objload == null) {
        loadmnemo.setAttribute('LoadObject', 'true');
        //HmiData.AnimationMnemo(loadmnemo, win);
    }

    if (loadstackmnemo.length !== 0) {
        setTimeout(ReloadMnemo, 500);
    }

    UpdateStyleMnemo(win);
}

let blockloadmnemo = false;
let loadstackmnemo: iloadstack[] = new Array();

//setInterval(UpdateStyle, 1000);

function UpdateStyleMnemo(win: any) {
    if (win != window) {
        let parentStyleSheets = document.styleSheets;
        let cssString = '';
        for (let i = 0, count = parentStyleSheets.length; i < count; ++i) {
            if (parentStyleSheets[i].cssRules) {
                let cssRules = parentStyleSheets[i].cssRules;
                for (let j = 0, countJ = cssRules.length; j < countJ; ++j) cssString += cssRules[j].cssText;
            }
        }

        if (win.document != null) {
            let styleold = win.document.querySelector('style[wincopy]');

            let style = win.document.createElement('style');
            style.type = 'text/css';
            style.setAttribute('wincopy', 'true');
            style.innerHTML = cssString;

            if (styleold == null || styleold?.innerHTML != style.innerHTML) {
                win.document.getElementsByTagName('head')[0].appendChild(style);

                if (styleold != null) {
                    styleold.remove();
                }
            }
        }
    }
}

function UpdateStyle() {
    //framewindow
    for (let i = 0; i < MnemoList.length; i++) {
        let win = MnemoList[i].framewindow;
        UpdateStyleMnemo(win);
    }

    setTimeout(UpdateStyle, 100);
}

//UpdateStyle();

export function GetMnemoAlarms(namemnemo: string) {
    let result;
    let loadmnemoo: any = {};
    loadmnemoo.name = namemnemo;
    loadmnemoo.gennum = {};
    loadmnemoo.binding = null;
    loadmnemoo.parentElem = {};
    loadmnemoo.callbackEnd = {};

    //Проверка открывалась ли мнемосхема
    if (!MnemoParams[namemnemo]) {
        let func = function (response: any, loadmnemoo: any) {
            let elem = response;
            let gennum = loadmnemoo.gennum;
            SetBindings(gennum, elem);
            findElementsWithOpenFaceplate(elem, namemnemo);

            let result: AlarmsInterface = {
                Alarms: [],
                Top: []
            };

            for (let i = window.Base.Events.GetActiveEvents().ActiveEvents.length - 1; i >= 0; i--) {
                let aevent = window.Base.Events.GetActiveEvents().ActiveEvents[i];
                let hasAck = ((aevent.NewState >> 2) & 1) == 1;

                if (Object.keys(MnemoParams).length != 0) {
                    for (let key in MnemoParams) {
                        if (MnemoParams[namemnemo].Alarms.includes(aevent.Block)) {
                            const ms: any = {
                                id: aevent.ID,
                                NewState: aevent.NewState,
                                hasAck: hasAck,
                                folder: aevent.Block,
                                Background: aevent.Background
                            };

                            result.Alarms.push(ms);
                            if (result.Top.length < 1) {
                                result.Top.push(ms);
                            }

                            break;
                        }
                    }
                }
            }

            return result;
        };
        let resFile = GetFile(namemnemo, null, loadmnemoo, false);
        return func(resFile, loadmnemoo);
    } else {
        return window.Base.Events.GetActiveEvents().CentumVP.MnemoAlrm[namemnemo];
    }
}

async function GetFile(name: string, callbackEnd: any, objectparam: any, asyncxhr: boolean = true) {
    let idpro = window.GetIdAndHost().id;
    const Store = rootStore;

    let reqFunc = (xhr: XMLHttpRequest) => {
        if (xhr.status === 200) {
            if (name) Store.SystemStore.mnemoPath = { path: name, bindings: objectparam.binding };
            let doc = xhr.responseXML;
            if (doc == null) {
                let parser = new DOMParser();
                if (xhr.responseText === null || xhr.responseText === undefined || xhr.responseText.trim() === '') {
                    Store.SystemStore.message = 'Файл не существует';
                } else {
                    doc = parser.parseFromString(xhr.responseText, 'text/html');
                }
            }
            if (asyncxhr) callbackEnd(StringToDom(doc), objectparam);
            else return StringToDom(doc);
        } else {
            blockloadmnemo = false;

            if (loadstackmnemo.length !== 0) {
                setTimeout(ReloadMnemo, 500);
            }
        }
    };

    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/ixyber/vision/File/OpenImage?idpro=' + idpro + '&Name=' + name, asyncxhr);
    //xhr.setRequestHeader("Content-type", "application/xml");
    if (asyncxhr) {
        return new Promise((resolve, reject) => {
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(reqFunc(xhr));
                    } else {
                        reject('Error: ' + xhr.statusText);
                    }
                }
            };
            xhr.send(null);
        });
    }
    xhr.send(null);

    if (!asyncxhr) return reqFunc(xhr);

    return null;
}

function StringToDom(str: any) {
    let xmlDoc = null;

    xmlDoc = str?.firstElementChild;

    /*
    var container = document.createElement("div");
    container.innerHTML = str;
    xmlDoc = container.firstChild;
    */
    /*
    if (window.DOMParser) {
        var parser = new DOMParser();
        xmlDoc = parser.parseFromString(str, "text/html");
        
        if (xmlDoc.head.innerHTML == "" && xmlDoc.body.children.length == 1) {
            xmlDoc = xmlDoc.body.children[0];
        }
    }*/
    return xmlDoc;
}

export function DonwloadJson(txt: string) {
    let download = document.createElement('a');
    download.href = '/ixyber/vision/File/DonwloadJson?json=' + encodeURIComponent(txt);

    download.style.display = 'none';
    download.id = 'download';
    document.body.appendChild(download);
    download.click();
    download.remove();

    /*
    var xhr = new XMLHttpRequest();

    var body = 'json=' + encodeURIComponent(txt);

    xhr.open("POST", '/ixyber/vision/File/DonwloadJson', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(body);

*/
}

interface iloadstack {
    name: string;
    gennum: any;
    binding: any;
    parentElem: any;
    callbackEnd: any;
}
